<template>
  <div class="browserTips"> 
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
export default {
    name: 'browserTips',
        data () {
        return {
        }
    },
  
    props:{
        tipMsg:{
            type:Object,
        }
    },
    created(){
        var that = this;
        var browser = {
            versions: function() {
                var u = navigator.userAgent;
                return {
                    trident: u.indexOf('Trident') > -1, //IE内核
                    presto: u.indexOf('Presto') > -1, //opera内核
                    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                    gecko: u.indexOf('Firefox') > -1, //火狐内核Gecko
                    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios
                    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android
                    iPhone: u.indexOf('iPhone') > -1 , //iPhone
                    iPad: u.indexOf('iPad') > -1, //iPad
                    webApp: u.indexOf('Safari') > -1 //Safari
                };
            }()
        }  
        if (!browser.versions.gecko && !browser.versions.webKit) {
            const h = this.$createElement;
            this.$msgbox({
                title: that.tipMsg.title,
                showCancelButton: false,
                message: h('p', null, [
                    h('span', null, that.tipMsg.content)
                ]),
                closeOnClickModal:false,
                showCancelButton: false,
                confirmButtonText: '确定',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        window.open(that.tipMsg.downloadUrl, "blank")
                        done();
                        // instance.confirmButtonLoading = true;
                        // instance.confirmButtonText = '下载中...';
                        // setTimeout(() => {
                        //     done();
                        //     setTimeout(() => {
                        //     instance.confirmButtonLoading = false;
                        //     instance.confirmButtonText = '下载完成';
                        //     }, 300);
                        // }, 3000);
                    } else {
                        done();
                    }
                }
            }).then(action => {
                
                // this.$alert('已下载完毕', '提醒', {
                //     confirmButtonText: '确定',
                //     callback: action => {

                //     }
                // });
            });

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

 #browserTips{
    background-color: rgba(0,0,0,0.5);
    color: #fff;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    padding:15px;
    display: none;
}

#browserTips.active {
    display: block;
}

</style>



// WEBPACK FOOTER //
// browserTips.vue?36d81b28